import axios from './axios';
import Mappings from './api.mappings';
export class BizpropertyApi {
    sortkeys(params) {
        return axios.put(Mappings.bizproperty.sortkeys, params);
    }
    listBySchemacode(params) {
        return axios.get(Mappings.bizRule.listBySchemacode, {
            params
        });
    }
    businessruleDelete(params) {
        return axios.delete(Mappings.bizRule.delete, {
            params
        });
    }
    businessruleDetails(params) {
        return axios.get(Mappings.bizRule.get, {
            params
        });
    }
    // 查看引用
    businessruleQuote(params) {
        return axios.get(Mappings.bizRule.quote, {
            params
        });
    }
    businessruleCreate(params) {
        return axios.post(Mappings.bizRule.create, params);
    }
    businessruleUpdata(params) {
        return axios.post(Mappings.bizRule.updata, params);
    }
    getBusinessRuleEnable(params) {
        return axios.get(Mappings.bizproperty.getBusinessRuleEnable, {
            params
        });
    }
    setBusinessRuleEnable(params) {
        return axios.put(Mappings.bizproperty.setBusinessRuleEnable, params);
    }
    /**
     * 校验子表映射接口
     * @param params
     */
    checkSheetMapping(params) {
        return axios.post('/api/app/bizmethod/compare_mapping?schemaCode=' + params.schemaCode + '&relativeCode=' + params.relativeCode, params.mappings);
    }
    // 获取业务规则节点运行轨迹
    getNodeRunMaps(params) {
        return axios.get(Mappings.bizRule.getNodeRunMaps, {
            params
        });
    }
}
;
